import { FormField } from "@/lib/database/forms";
import { ReactElement, useId } from "react";

interface FieldCommentProps {
  field: FormField;
  value: unknown;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * Optional free-text comment shown under a field when `has_comment` is set.
 * The answer is stored separately from the field's main answer (under the
 * `${label} (comment)` sibling key), so this is rendered alongside — not inside —
 * `FormFieldRenderer`, by every renderer that shows a form.
 */
export const FieldComment = ({ field, value, onChange, disabled = false }: FieldCommentProps): ReactElement | null => {
  const commentId = useId();
  if (!field.has_comment) return null;
  return (
    <div className="mt-2">
      <label htmlFor={commentId} className="mb-1 block text-sm font-medium text-gray-600">
        {field.comment_label || "Comment (optional)"}
      </label>
      <textarea
        id={commentId}
        value={typeof value === "string" ? value : ""}
        onChange={(e) => onChange(e.target.value)}
        maxLength={field.max_length}
        rows={2}
        disabled={disabled}
        className="w-full touch-manipulation rounded-lg border border-gray-300 p-2 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-50"
      />
    </div>
  );
};
